import * as React from "react";
import type { SVGProps } from "react";
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#79AFFF"
      d="M66.64 33.333V60c0 10-3.333 13.333-13.333 13.333H26.64c-10 0-13.333-3.333-13.333-13.333V33.333H66.64Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="M71.74 23.333v3.334c0 3.666-1.767 6.666-6.667 6.666h-50c-5.1 0-6.667-3-6.667-6.666v-3.334c0-3.666 1.567-6.666 6.667-6.666h50c4.9 0 6.667 3 6.667 6.666Z"
    />
    <path
      fill="#79AFFF"
      d="M38.873 16.667h-18.4a3.121 3.121 0 0 1 .1-4.334L25.306 7.6a3.199 3.199 0 0 1 4.5 0l9.067 9.067ZM59.64 16.667h-18.4L50.307 7.6a3.199 3.199 0 0 1 4.5 0l4.733 4.733c1.2 1.2 1.234 3.1.1 4.334Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="M29.873 33.333v17.134c0 2.666 2.933 4.233 5.167 2.8l3.133-2.067c1.133-.733 2.567-.733 3.667 0l2.966 2c2.2 1.467 5.167-.1 5.167-2.767v-17.1h-20.1Z"
      opacity={0.6}
    />
  </svg>
);
export default SvgGift;
